import { Stack } from '@mui/material';
import { useBoundStore } from 'useStore';
import FilterChip from './utils/FilterChip';

export default function DomainFiltersChip() {
	const selectedDomain = useBoundStore(
		(state) => state.productMasterStSelectedDomains
	);
	const clearSelectedDomain = useBoundStore(
		(state) => state.clearProductMasterStSelectedDomains
	);
	if (selectedDomain.length === 0) return null;

	return (
		<Stack direction="row" flexWrap="wrap" gap={1}>
			<FilterChip
				filterName="Dominio"
				title={selectedDomain}
				onDelete={() => clearSelectedDomain()}
			/>
		</Stack>
	);
}
